import { Component, OnInit, EventEmitter, QueryList, ViewChildren, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { SnackService } from '@shared/services/snack.service';
import { AuthService } from '@shared/services/auth.service';
import { ViewportService } from '@shared/services/viewport.service';
import { LocaleService } from '@shared/services/locale.service';
import { Title } from '@angular/platform-browser';
import { ApiService } from '@shared/services/api.service';
import { NumbersService } from '@shared/services/numbers.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { HttpClient, HttpEventType } from '@angular/common/http';
import imageCompression from 'browser-image-compression';
import { CanComponentDeactivate } from '@core/guards/can-deactivate-post-ad-dialog.guard';
import { AuthFacade } from '../auth/auth.facade';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment as env } from '@environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { VideoModalComponent } from '@shared/components/video-modal/video-modal.component';
import { CookieService } from 'ngx-cookie-service';
import { AdsApi } from '@core/apis/ads.api';

@Component({
	selector: 'app-place-ad',
	templateUrl: './place-ad.component.html',
	styleUrls: ['./place-ad.component.scss'],
	providers: [AuthFacade],
})
export class PlaceAdComponent implements OnInit, CanComponentDeactivate {
	constructor(
		private router: Router,
		private snack: SnackService,
		private title: Title,
		private api: ApiService,
		private auth: AuthService,
		public viewport: ViewportService,
		public locale: LocaleService,
		public numbers: NumbersService,
		private readonly authFacade: AuthFacade,
		private readonly deviceDetectorService: DeviceDetectorService,
		private dialog: MatDialog,
		public httpClient: HttpClient,
		private cookie: CookieService,
		private adsApi: AdsApi
	) {}
	file: any;
	localUrl: any;
	localCompressedURl: any;
	sizeOfOriginalImage: number;
	sizeOFCompressedImage: number;
	imgResultBeforeCompress: string;
	imgResultAfterCompress: string;

	loading: boolean = true;
	adID: string = '';
	selectedValue: any;
	showCategory: boolean = false;
	categories = [];
	dealersCategories: [];
	subcategories = [];
	locations = [];
	popularLocations = [];
	motorData = {};
	electronicData = {};
	models = [];
	i: any = 0;
	images: {
		file?: File;
		url: string | ArrayBuffer;
		progress: number;
		uploadID: string;
	}[] = [];
	deletedImageID = [];
	coverImage: string;
	isMobile: boolean = false;
	canExit: boolean = false;
	user: Object = this.auth.user();
	filterselectedCountryPrefix: any = [];
	selectedCountryPrefix: any = [];
	rotateAd = '/assets/images/place-ad-rotate';
	validMobile: boolean = true;
	isFormSubmitted: boolean = false;
	isImageUploaded: boolean = false;
	successfulImgUploadLength: number = 0;
	@ViewChildren('adImage') adImage: QueryList<PlaceAdComponent>;

	form: UntypedFormGroup = new UntypedFormGroup({
		phonePrefix: new UntypedFormControl(this.user ? localStorage.getItem('prefix') : '+964', Validators.required),
		phone: new UntypedFormControl('', [Validators.required, Validators.minLength(10)]),
		contactTypeWhatsapp: new UntypedFormControl(false, Validators.required),
		contactTypeViber: new UntypedFormControl(false, Validators.required),
		category: new UntypedFormControl(null, Validators.required),
		subcategory: new UntypedFormControl(null, Validators.required),
		title: new UntypedFormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(150)]),
		description: new UntypedFormControl(null, [Validators.required, Validators.minLength(5), Validators.maxLength(5000)]),
		price: new UntypedFormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(10)]),
		location: new UntypedFormControl(null, Validators.required),
	});

	searchTextCat = new UntypedFormControl('');
	searchTextSubCat = new UntypedFormControl('');
	searchTextBrand = new UntypedFormControl('');
	searchTextModel = new UntypedFormControl('');
	searchTextLocation = new UntypedFormControl('');
	searchTextMake = new UntypedFormControl('');
	searchTextYear = new UntypedFormControl('');
	searchTextColor = new UntypedFormControl('');
	searchTextStorage = new UntypedFormControl('');
	searchTextMemory = new UntypedFormControl('');
	searchTextProcessor = new UntypedFormControl('');
	searchTextGraphics = new UntypedFormControl('');
	searchTextNetwork = new UntypedFormControl('');
	@HostListener('window:beforeunload')
	onOpenWhatsapp() {
		const targetDisplay = this.deviceDetectorService.isMobile() ? '_self' : '_blank';

		window.open(env.WHATSAPP.callForHelpUrl, targetDisplay);
	}

	onClearSearch(searchTextControl: UntypedFormControl) {
		//for brand and make we are reseting searchTextBrand and searchTextModel from brandSelection(),makeSelection() function
		setTimeout(() => {
			searchTextControl.setValue('');
		});
	}
	canDeactivate() {
		if (this.isFormSubmitted) {
			return false;
		}

		if (this.form.dirty) {
			return true;
		} else {
			return false;
		}
	}

	onSelect(id: any) {
		this.form.get('phonePrefix').setValue(id);
	}

	onKey(value) {
		value == '' ? (this.filterselectedCountryPrefix = this.selectedCountryPrefix) : (this.filterselectedCountryPrefix = this.search(value));
	}

	search(value: string) {
		let filter = value.toLowerCase();
		return this.selectedCountryPrefix.filter((option) => option.name.toLowerCase().includes(filter));
	}

	onMakeSelection(event: EventEmitter<MatSelectChange>) {
		this.form.get('model').reset();
		this.loading = true;

		let formData: FormData = new FormData();
		formData.append('makeID', event['value']);
		formData.append('lang', this.locale.lang);

		this.api.models(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.models = res['response'];
			} else {
				this.snack.open(this.locale.translations['ads']['filter']['s2']);
			}

			this.loading = false;
		});
	}

	onBrandSelection(event: EventEmitter<MatSelectChange>) {
		this.form.get('eModel').reset();
		this.loading = true;

		let formData: FormData = new FormData();
		formData.append('brandID', event['value']);
		formData.append('subCatID', this.form.get('subcategory').value);
		formData.append('lang', this.locale.lang);

		this.api.electronicModels(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.models = res['response'];
			} else {
				this.snack.open(this.locale.translations['ads']['filter']['s2']);
			}

			this.loading = false;
		});
	}

	generateMotorTitle(makeID: string, modelID: string, year: string): string {
		let make: string = '';
		let model: string = '';

		// find make name by id
		(<[any]>this.motorData['makes']).forEach((_make) => {
			if ((<number>_make['id']).toString() === makeID) {
				make = (<number>_make['name']).toString();
			}
		});

		// find model name by id
		this.models.forEach((_model) => {
			if ((<number>_model['id']).toString() === modelID) {
				model = _model['name'];
			}
		});

		return make + ' ' + model + ' ' + year;
	}

	generateElectronicTitle(brandID: string, modelID: string): string {
		let eBrand: string = '';
		let eModel: string = '';
		// find brand name by id
		(<[any]>this.electronicData['brands']).forEach((_eBrand) => {
			if ((<number>_eBrand['id']).toString() === brandID) {
				eBrand = (<number>_eBrand['name']).toString();
			}
		});

		// find model name by id
		this.models.forEach((_eModel) => {
			if ((<number>_eModel['id']).toString() === modelID) {
				eModel = _eModel['name'];
			}
		});

		return eBrand + ' ' + eModel;
	}

	onSubmit() {
		this.isFormSubmitted = true;
		this.loading = true;
		let formData: FormData = new FormData();

		// images
		this.images.forEach((image) => {
			formData.append('uploadImageIDs[]', image['uploadID']);
		});

		if (this.coverImage !== undefined) {
			formData.append('coverImage', this.coverImage);
		}

		// standard data
		formData.append('lang', this.locale.lang);
		formData.append('platform', 'Web');

		//To check whether its a test number then retrieve actual number else save same number
		const ORIGINAL_PHONE_NUMBER = this.authFacade.getTestPhoneNumber(this.form.get('phone').value.substring(2));

		if (this.user) {
			formData.append('userID', this.user['userID']);
		}

		if (this.form.get('category').value === '15' && this.form.get('subcategory').value === '291') {
			formData.append('title', this.generateMotorTitle(this.form.get('make').value, this.form.get('model').value, this.form.get('year').value));
		} else if (
			this.form.get('category').value === '16' &&
			(this.form.get('subcategory').value === '302' ||
				this.form.get('subcategory').value === '303' ||
				this.form.get('subcategory').value === '304' ||
				this.form.get('subcategory').value === '305' ||
				this.form.get('subcategory').value === '306' ||
				this.form.get('subcategory').value === '307' ||
				this.form.get('subcategory').value === '308' ||
				this.form.get('subcategory').value === '309' ||
				this.form.get('subcategory').value === '310' ||
				this.form.get('subcategory').value === '311' ||
				this.form.get('subcategory').value === '312' ||
				this.form.get('subcategory').value === '313' ||
				this.form.get('subcategory').value === '365' ||
				this.form.get('subcategory').value === '366' ||
				this.form.get('subcategory').value === '367' ||
				this.form.get('subcategory').value === '370' ||
				this.form.get('subcategory').value === '371' ||
				this.form.get('subcategory').value === '372' ||
				this.form.get('subcategory').value === '373')
		) {
			formData.append('title', this.generateElectronicTitle(this.form.get('eBrand').value, this.form.get('eModel').value));
		} else {
			formData.append('title', this.form.get('title').value);
		}

		formData.append('adID', this.adID);
		formData.append('catID', this.form.get('category').value);
		formData.append('subCatID', this.form.get('subcategory').value);
		formData.append('phone', ORIGINAL_PHONE_NUMBER);
		formData.append('description', this.form.get('description').value);
		formData.append('price', this.form.get('price').value);
		formData.append(
			'phonePrefix',
			this.form.get('phonePrefix').value ? this.form.get('phonePrefix').value : localStorage.getItem('prefix') ? localStorage.getItem('prefix') : '+964'
		);
		formData.append('locationID', this.form.get('location').value);
		let contactTypeWhatsapp = this.form.get('contactTypeWhatsapp').value ? '1' : '0';
		let contactTypeViber = this.form.get('contactTypeViber').value ? '1' : '0';
		formData.append('contactTypeWhatsapp', contactTypeWhatsapp);
		formData.append('contactTypeViber', contactTypeViber);

		// motor data
		if (this.form.get('category').value === '15' && this.form.get('subcategory').value === '291') {
			formData.append('motorMakeID', this.form.get('make').value);
			formData.append('motorModelID', this.form.get('model').value);
			formData.append('motorYear', this.form.get('year').value);
			formData.append('motorColorID', this.form.get('color').value);
		}
		// 	 //electronic data
		if (
			this.form.get('category').value === '16' &&
			(this.form.get('subcategory').value === '302' ||
				this.form.get('subcategory').value === '303' ||
				this.form.get('subcategory').value === '304' ||
				this.form.get('subcategory').value === '305' ||
				this.form.get('subcategory').value === '306' ||
				this.form.get('subcategory').value === '307' ||
				this.form.get('subcategory').value === '308' ||
				this.form.get('subcategory').value === '309' ||
				this.form.get('subcategory').value === '310' ||
				this.form.get('subcategory').value === '311' ||
				this.form.get('subcategory').value === '312' ||
				this.form.get('subcategory').value === '313' ||
				this.form.get('subcategory').value === '365' ||
				this.form.get('subcategory').value === '366' ||
				this.form.get('subcategory').value === '367' ||
				this.form.get('subcategory').value === '370' ||
				this.form.get('subcategory').value === '371' ||
				this.form.get('subcategory').value === '372' ||
				this.form.get('subcategory').value === '373')
		) {
			formData.append('electronicBrandID', this.form.get('eBrand').value);
			formData.append('electronicModelID', this.form.get('eModel').value);
			formData.append('electronicColorID', this.form.get('eColor').value);
			formData.append('electronicStorageID', this.form.get('eStorage').value);
			formData.append('electronicMemoryID', this.form.get('eMemory').value);
			formData.append('electronicProcessorID', this.form.get('eProcessor').value);
			formData.append('electronicGraphicsID', this.form.get('eGraphic').value);
			formData.append('electronicNetworkID', this.form.get('eNetwork').value);
		}
		// api call

		this.api.placeAd(formData).subscribe((res) => {
			this.loading = false;
			this.canExit = true;

			if (res['status'] === '1') {
				this.adsApi.upgradeAd.next(true);
				if (this.user) {
					this.router.navigate(['/payment/tier'], {
						queryParams: {
							adID: res['response']['id'],
							from: 'pa',
						},
					});
				} else {
					this.router.navigate(['/login'], {
						queryParams: {
							from: 'pa',
							id: res['response']['id'],
							prefix: this.form.get('phonePrefix').value,
							phone: this.form.get('phone').value,
						},
					});
				}
			} else {
				this.snack.open(res['message']);
			}
		});
	}

	clearFormFieldValidators(formFieldName: string) {
		const FORM_FIELD = this.form.get(formFieldName);
		FORM_FIELD.setValue(''); // Clear the form control value
		FORM_FIELD.setErrors(null); // Clear any validation errors
		FORM_FIELD.markAsPristine(); // Mark the control as pristine
		FORM_FIELD.markAsUntouched(); // Mark the control as untouched
	}

	onCategorySelection(event: EventEmitter<MatSelectChange>) {
		// clear form and images
		// this.form.reset({ category: event['value'] });
		// this.images = [];
		// this.coverImage = undefined;

		// fetch subcategories
		this.categories.forEach((category) => {
			if (category['id'] === event['value']) {
				this.subcategories = category['subCategories'];
			}
		});

		this.form.get('subcategory').reset();
		if (this.form.controls.description.value) {
			this.form.get('description').reset();
			this.form.get('description').setErrors(null);
		}
	}

	onSubcategorySelection(event: EventEmitter<MatSelectChange>) {
		if (this.form.get('category').value === '15' && event['value'] === '291') {
			this.loading = true;

			this.form.addControl('make', new UntypedFormControl(null, Validators.required));
			this.form.addControl('model', new UntypedFormControl(null, Validators.required));
			this.form.addControl('year', new UntypedFormControl(null, Validators.required));
			this.form.addControl('color', new UntypedFormControl(null, Validators.required));
			this.form.removeControl('eBrand');
			this.form.removeControl('eModel');
			this.form.removeControl('eColor');
			this.form.removeControl('eStorage');
			this.form.removeControl('eMemory');
			this.form.removeControl('eProcessor');
			this.form.removeControl('eGraphic');
			this.form.removeControl('eNetwork');
			this.form.removeControl('title');

			// fetch data
			let motorFormData: FormData = new FormData();
			motorFormData.append('lang', this.locale.lang);

			this.api.motorData(motorFormData).subscribe((res) => {
				if (res['status'] === '1') {
					this.motorData = res['response'];
				} else {
					this.snack.open(this.locale.translations['ads']['filter']['s4']);
				}

				this.loading = false;
			});
		}
		//add elecronic data
		else if (
			this.form.get('category').value === '16' &&
			(event['value'] === '302' ||
				event['value'] === '303' ||
				event['value'] === '304' ||
				event['value'] === '305' ||
				event['value'] === '306' ||
				event['value'] === '307' ||
				event['value'] === '308' ||
				event['value'] === '309' ||
				event['value'] === '310' ||
				event['value'] === '311' ||
				event['value'] === '312' ||
				event['value'] === '313' ||
				event['value'] === '365' ||
				event['value'] === '366' ||
				event['value'] === '367' ||
				event['value'] === '370' ||
				event['value'] === '371' ||
				event['value'] === '372' ||
				event['value'] === '373')
		) {
			this.loading = true;

			this.form.addControl('eBrand', new UntypedFormControl(null, Validators.required));
			this.form.addControl('eModel', new UntypedFormControl(null));
			this.form.addControl('eColor', new UntypedFormControl(null, Validators.required));
			this.form.addControl('eStorage', new UntypedFormControl(null));
			this.form.addControl('eMemory', new UntypedFormControl(null));
			this.form.addControl('eProcessor', new UntypedFormControl(null));
			this.form.addControl('eGraphic', new UntypedFormControl(null));
			this.form.addControl('eNetwork', new UntypedFormControl(null));
			this.form.removeControl('make');
			this.form.removeControl('model');
			this.form.removeControl('year');
			this.form.removeControl('color');
			this.form.removeControl('title');

			// fetch data
			let ElectronicFormData: FormData = new FormData();
			ElectronicFormData.append('lang', this.locale.lang);

			this.api.electronicFilterData(ElectronicFormData).subscribe((res) => {
				if (res['status'] === '1') {
					this.electronicData = res['response'];
				} else {
					this.snack.open(this.locale.translations['ads']['filter']['s4']);
				}

				this.loading = false;
			});
		} else if (
			!(
				event['value'] === '291' ||
				event['value'] === '302' ||
				event['value'] === '303' ||
				event['value'] === '304' ||
				event['value'] === '305' ||
				event['value'] === '306' ||
				event['value'] === '307' ||
				event['value'] === '308' ||
				event['value'] === '309' ||
				event['value'] === '310' ||
				event['value'] === '311' ||
				event['value'] === '312' ||
				event['value'] === '313' ||
				event['value'] === '365' ||
				event['value'] === '366' ||
				event['value'] === '367' ||
				event['value'] === '370' ||
				event['value'] === '371' ||
				event['value'] === '372' ||
				event['value'] === '373'
			)
		) {
			this.form.addControl('title', new UntypedFormControl(null, Validators.required));
			this.form.removeControl('eBrand');
			this.form.removeControl('eModel');
			this.form.removeControl('eColor');
			this.form.removeControl('eStorage');
			this.form.removeControl('eMemory');
			this.form.removeControl('eProcessor');
			this.form.removeControl('eGraphic');
			this.form.removeControl('eNetwork');
			this.form.removeControl('make');
			this.form.removeControl('model');
			this.form.removeControl('year');
			this.form.removeControl('color');
		}
	}

	onImageFileSelection($event) {
		const NEW_FILE = $event.target.files[0];
		const EXISTING_IMAGES = this.images.map((image) => image.file.name);

		for (let index = 0; index < $event['target']['files'].length; index++) {
			// Check if the file already exists in the images array
			if (EXISTING_IMAGES.includes(NEW_FILE.name)) {
				this.snack.open('this file is already uploaded');
				return; // Skip uploading the duplicate image
			}

			if (this.images.length + index >= 10) {
				this.snack.open(this.locale.translations['place-ad']['photos']['n175']);
				return;
			}

			const file = $event['target']['files'][index];
			const fileReader: FileReader = new FileReader();

			fileReader.onloadend = async (event) => {
				const current = this.images.push({ url: fileReader.result, progress: null, uploadID: null, file: file }) - 1;
				let compressFile = await this.handleImageUpload(file);
				const imageFormData: FormData = new FormData();
				imageFormData.append('lang', this.locale.lang);
				imageFormData.append('image', compressFile, compressFile['name']);
				imageFormData.append('adID', this.adID);
				imageFormData.append('phonePrefix', this.form.get('phonePrefix').value);
				imageFormData.append('phone', this.form.get('phone').value);
				imageFormData.append('expressAd', index === 0 ? '1' : '');
				imageFormData.append('rotateImage', '0');

				this.isImageUploaded = false;
				this.api.uploadImageRaw(imageFormData).subscribe(
					(event) => {
						if (event['type'] === HttpEventType.UploadProgress) {
							this.images[current]['progress'] = Math.round((event['loaded'] / event['total']) * 100);
						} else if (event['type'] === HttpEventType.Response) {
							if (event['body']['status'] === '1') {
								this.successfulImgUploadLength = this.successfulImgUploadLength + 1;
								if (this.successfulImgUploadLength === this.images.length) {
									this.isImageUploaded = true;
								}
								this.images[current]['uploadID'] = event['body']['response']['uploadID'];
								this.images[current]['url'] = event['body']['response']['path'];

								if (this.adID === '') {
									this.adID = event['body']['response']['adID'];
								}

								this.auth.intercomUpdate(this.adID);
							}
						}
					},
					(err) => {
						this.onImageDelete(current);
						console.log('Oops, image failed to upload.', err);
					}
				);
			};

			fileReader.readAsDataURL(file);
		}
	}

	onImageCover(index: number) {
		this.coverImage = this.images[index]['uploadID'];
	}

	rotateImageDiv(e, index, setBase64) {
		e.stopImmediatePropagation();
		var canvas = document.getElementById('canvas') as any;
		var ctx = canvas.getContext('2d');
		var image = new Image();
		image.setAttribute('crossOrigin', 'anonymous');
		image.src = this.images[index].url as any;
		image.onload = function () {
			canvas.height = image.width;
			canvas.width = image.height;
			image.width = canvas.width;
			image.height = canvas.height;
			ctx.translate(image.width, image.height / image.width);
			ctx.rotate(Math.PI / 2);
			ctx.drawImage(image, 0, 0);
			setBase64(canvas.toDataURL());
			ctx.restore();
			image = null;
		};
	}

	rotateImage(e, index) {
		const ROTATE_IMAGE = this.images[index];
		this.rotateImageDiv(e, index, async (url) => {
			this.images[index].url = url;
			let blob = await this.dataURLtoBlob(url);
			this.onImageDelete(index, true); //delete existing image on rotate and upload new rotate inplace of old
			this.images[index] = { url: url, progress: null, uploadID: null, file: ROTATE_IMAGE.file };
			let compressFile = await this.handleImageUpload(blob);
			const imageFormData: FormData = new FormData();
			imageFormData.append('lang', this.locale.lang);
			imageFormData.append('image', compressFile, compressFile['name']);
			imageFormData.append('adID', this.adID);
			imageFormData.append('phonePrefix', this.form.get('phonePrefix').value);
			imageFormData.append('phone', this.form.get('phone').value);
			imageFormData.append('expressAd', index === 0 ? '1' : '');
			imageFormData.append('rotateImage', '1');

			this.api.uploadImageRaw(imageFormData).subscribe(
				(event) => {
					if (event['type'] === HttpEventType.UploadProgress) {
						this.images[index]['progress'] = Math.round((event['loaded'] / event['total']) * 100);
					} else if (event['type'] === HttpEventType.Response) {
						if (event['body']['status'] === '1') {
							this.images[index]['uploadID'] = event['body']['response']['uploadID'];

							if (this.adID === '') {
								this.adID = event['body']['response']['adID'];
							}
						}
					}
				},
				(err) => {
					this.onImageDelete(index);
					console.log('Oops, image failed to upload.', err);
				}
			);
		});
	}

	async dataURLtoBlob(dataurl) {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}

		return new Blob([u8arr], { type: mime });
	}

	onImageDelete(index: number, rotate = false) {
		if (this.images[index]['uploadID'] === this.coverImage) {
			this.coverImage = undefined;
		}

		if (!this.images[index]['new']) {
			this.deletedImageID.push(this.images[index]['uploadID']);
		}

		const deleteImagesFormData: FormData = new FormData();
		deleteImagesFormData.append('lang', this.locale.lang);
		deleteImagesFormData.append('adID', this.adID);

		if (this.user && this.user['userID']) {
			deleteImagesFormData.append('userID', this.user['userID']);
		}

		const uploadKey = this.user && this.user['userID'] ? 'imageID' : 'uploadID';
		deleteImagesFormData.append(uploadKey, this.images[index]['uploadID']);

		this.api.deleteImage(deleteImagesFormData).subscribe(
			(res) => {
				if (!rotate) {
					this.images.splice(index, 1);
					if (this.successfulImgUploadLength > 0) {
						this.successfulImgUploadLength--;
					}
				}

				this.loading = false;
			},
			(err) => {
				this.loading = false;
				this.snack.open(err);
			}
		);
	}

	imagesUploaded(): boolean {
		return this.images.every((image) => image['progress'] === 100);
	}

	onPriceKeyUp() {
		this.form.get('price').setValue(this.numbers.toNumeric(this.form.get('price').value.toString().replace(/\s/g, '')));
		this.form.get('price').markAsTouched();
		if (this.form.get('phone').value == null) {
			this.form.get('phone').setValue(this.user && this.user['phone'] ? this.user['phone'] : '');
			this.form.get('phonePrefix').setValue(this.user ? localStorage.getItem('prefix') : '+964');
		}
	}

	onPhoneKeyUp() {
		if (this.form.get('phone').value !== null) {
			let phoneNumber = this.numbers.toNumeric(this.form.get('phone').value.toString().replace(/\s/g, ''));

			// Ensure "07" prefix is always there
			if (!phoneNumber.startsWith('07')) {
				phoneNumber = '07' + phoneNumber;
			}

			if (phoneNumber.charAt(2) === '0') {
				phoneNumber = phoneNumber.slice(0, 2) + phoneNumber.slice(3);
			}

			if (phoneNumber.charAt(0) !== '0') {
				phoneNumber = '0' + phoneNumber;
			}

			if (phoneNumber.length < 10) {
				this.validMobile = false;
			} else {
				this.validMobile = true;
			}

			this.form.get('phone').setValue(phoneNumber);
		}
	}

	//fctn to enter only digits
	isNumberKey(evt) {
		let charCode = evt.which ? evt.which : evt.keyCode;

		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			this.validMobile = false;
			return false;
		}

		return true;
	}

	autoFocus() {
		const searchbox = document.getElementById('searchbox');
		if (searchbox && this.viewport.type === 'desktop') {
			searchbox.focus();
		}
	}

	ngOnInit(): void {
		//country prefix code
		this.loading = true;

		this.title.setTitle(this.locale.translations['header']['n10'] + ' | ' + this.locale.translations['header']['n0']);
		if (this.user) {
			const phoneWithoutCountryCode = this.authFacade.getOriginalPhoneNumber(this.user['phone']);
			this.form.get('phone').setValue(phoneWithoutCountryCode);
		}

		// fetch categories

		let catFormData: FormData = new FormData();
		catFormData.append('lang', this.locale.lang);

		this.api.categories(catFormData).subscribe((res) => {
			this.categories = res['response'];
			this.loading = false;
			// for dealer section only motors is category so after showCategory is true display only motors on index=0 and their subcategories
			if (this.user && this.user['userType'] === '1') {
				this.showCategory = true;
				this.form.get('category').setValue(this.categories[0]['id']);
				this.categories.forEach((category) => {
					if (category['id'] === this.categories[0]['id']) {
						this.subcategories = category['subCategories'];
					}
				});

				// if only one subcategory available, default to it
				if (this.subcategories.length <= 1) {
					this.form.get('subcategory').setValue(this.subcategories[0]['id']);
				} else {
					this.form.get('subcategory').reset();
				}
			}
		});

		// fetch locations
		let locFormData: FormData = new FormData();
		locFormData.append('lang', this.locale.lang);

		this.api.locations(locFormData).subscribe((res) => {
			if (res['status'] === '1') {
				this.locations = res['response'];

				this.locations.forEach((location) => {
					if (location['id'] === '82' || location['id'] === '83' || location['id'] === '85' || location['id'] === '89') {
						this.popularLocations.push(location);
					}
				});

				this.locations = this.locations.filter((location) => {
					return !(location['id'] === '82' || location['id'] === '83' || location['id'] === '85' || location['id'] === '89');
				});
			} else {
				this.snack.open(this.locale.translations['ads']['filter']['s3']);
			}
		});
	}

	async handleImageUpload(event) {
		const imageFile = event;
		const options = {
			maxSizeMB: 2,
			maxWidthOrHeight: 1920,
			useWebWorker: true,
		};

		try {
			const compressedFile = await imageCompression(imageFile, options);
			return compressedFile;
		} catch (error) {
			console.log(error);
		}
	}
}
